export function prepareCreateGeoFenceRequest(values) {
    // Ensure the polygon is closed by repeating the first coordinate at the end if needed
    const coordinatesArray = values.geoFenceCoordinates?.map((coord) => [coord.lng, coord.lat]) || [];
    if (coordinatesArray.length > 0) {
        const first = coordinatesArray[0];
        const last = coordinatesArray[coordinatesArray.length - 1];
        if (first[0] !== last[0] || first[1] !== last[1]) {
            coordinatesArray.push([...first]);
        }
    }
    //const coordinates: Array<Array<Array<number>>> = [coordinatesArray];
    const coordinates = coordinatesArray;
    return {
        description: values.geofenceDesc,
        geoBoundary: {
            coordinates,
            type: "Polygon"
        },
        geofenceDisplayName: values.geofenceName,
        geofenceType: values.geofenceType
    };
}
export function prepareUpdateGeoFenceRequest(values) {
    // Ensure the polygon is closed by repeating the first coordinate at the end if needed
    const coordinatesArray = values.geoFenceCoordinates?.map((coord) => [coord.lng, coord.lat]) || [];
    if (coordinatesArray.length > 0) {
        const first = coordinatesArray[0];
        const last = coordinatesArray[coordinatesArray.length - 1];
        if (first[0] !== last[0] || first[1] !== last[1]) {
            coordinatesArray.push([...first]);
        }
    }
    //const coordinates: Array<Array<Array<number>>> = [coordinatesArray];
    const coordinates = coordinatesArray;
    return {
        description: values.geofenceDesc,
        geoBoundary: {
            coordinates,
            type: "Polygon"
        },
        geofenceDisplayName: values.geofenceName
    };
}
